import { useQuery } from '@apollo/client';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { BookmarkParentType } from '~/apollo/generated/v4/graphql';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { SOItemListV4 } from '~/components/supporting-object/so-item-list-v4';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';

const STUDY_TRAINING_IMAGES_PAGE = graphql(`
  query StudyTrainingImagesPage($id: ID!) {
    studyGet(id: $id) {
      id
      trainingImages {
        ...trainingImageParts
        pictures {
          ...soPictureParts
        }
        files {
          ...fileParts
        }
      }
    }
  }
`);

export default function StudyTrainingImagesPage() {
  return (
    <ApolloProviderV4>
      <StudyTrainingImagesPageInner />
    </ApolloProviderV4>
  );
}

function StudyTrainingImagesPageInner() {
  const studyId = useRouteParam('studyId', parseInt);

  const { data, loading } = useQuery(STUDY_TRAINING_IMAGES_PAGE, {
    variables: { id: studyId },
  });

  const refetchQueries = createRefetchQueries([
    { query: STUDY_TRAINING_IMAGES_PAGE, variables: { id: studyId } },
  ]);

  const trainingImages = data?.studyGet?.trainingImages ?? [];

  if (loading) return <SpinnerPlaceholder />;

  return (
    <SOItemListV4
      items={trainingImages}
      soParentType="study"
      soParentId={studyId}
      bookmarkParentType={BookmarkParentType.TrainingImage}
      refetchQueries={refetchQueries}
    />
  );
}
